import React, { useState } from 'react';
import logoFooter from '../../images/logo_Suburbia_Visa.png';


export const Footer = () => {
	const [isModalOpen, setIsModalOpen] = useState(false);
	const date = new Date();
	const year = date.getFullYear();

	return (
		<>
		{/* Esto es el modal */}
		{isModalOpen && (
			<div className="modal">
				<button className="modal-close" onClick={() => setIsModalOpen(false)}>Cerrar</button>
				<div className="modal-content">
					{}
					<h2>Términos y condiciones</h2>
					<p>
						(En adelante “Términos y Condiciones”)
					</p>

					<p>
						Pier Leal Marketing S.A.P.I. de C.V. (en adelante “Reworth”) es un medio informativo e independiente, el cual ofrece los servicios de publicidad de ofertas a diferentes establecimientos (en adelante los “Servicios”). 
					</p>
					<p>
						En virtud del uso de nuestros Servicios el cliente (en adelante el “Cliente”) acepta los presentes términos y condiciones, por lo que deberá leerlos detenidamente. 
					</p>
					<p>
						Hacemos de su conocimiento que Reworth no se hace responsable respecto al alcance o contenido de las ofertas (dicho término se define más adelante) debido a que las mismas son administradas y publicadas por cada establecimiento con la información que en su caso, cada uno de ellos desea transmitir. 
					</p>
					<p>
						Al aceptar los presente términos y condiciones, el Cliente reconoce que todos los datos e información aportados a Reworth son veraces, reales y comprobables, así como cualquier otro dato que ingrese a nuestra plataforma (en adelante la “Plataforma”) y faculta a Reworth para verificar, por si o a través de terceros, en cualquier momento los datos que el Cliente proporciona. En caso de que la información proporcionada resulte ser falsa o inexacta, Reworth podrá, a su entera discreción, negar el acceso a la Plataforma.  
					</p>
					<p>
						​En consecuencia, el Cliente libera a Reworth de cualquier responsabilidad derivada del uso de información inexacta que haya sido proporcionada por el Cliente, siendo responsable frente a Reworth de los daños y perjuicios que dicha información pudiera causar a Reworth o a otros Clientes o proveedores.  
					</p>
					<p>
						​En caso de hacer uso de la Plataforma o cualquier herramienta incluida en ella, el Cliente acepta que los procedimientos de seguridad de las cuentas de Reworth son comercialmente razonables. Asimismo, el Cliente reconoce la prohibición impuesta por Reworth para que los terceros no puedan hacer uso de su clave personal, toda vez que entiende que el uso de dicha clave debe realizarse de forma personal y directa por las personas registradas ante Reworth para dicho propósito. 
					</p>
					<h3>
						Primera. Definiciones. 
					</h3>
					<p>
					​	Los siguientes términos que sean escritos con letras mayúsculas (ya fuere que se utilicen en femenino o masculino, singular o plural), tendrán el significado que a continuación se les asigna: 
					</p>
					<p>
						Cashback: modalidad de Oferta en la que Reworth participa como intermediario entre Consumidores, Establecimientos e instituciones emisoras de Métodos de Pago. Conforme a esta modalidad de Oferta, Reworth recibe abonos de dinero por parte de Establecimientos a fin de que los transfiera a las instituciones emisoras de Métodos de Pago para que sean acreditados como reembolso a los Consumidores, en la proporción indicada por el Establecimiento, respecto al precio pagado por la adquisición de un bien o servicio en el Establecimiento correspondiente. 
					</p>
					<p>
						Consumidor: es la persona física o moral titular del Método de Pago que obtiene los bienes y/o servicios del Establecimiento. 
					</p>
					<p>
						Establecimiento o Cliente: es la persona física o moral que, a través de la  plataforma digital Reworth, publicita las Ofertas o beneficios que ofrece. 
					</p>
					<p>
						Método(s) de Pago: es un producto financiero utilizado para realizar el pago correspondiente a la adquisición de bienes o servicios, emitido por las instituciones con las que Reworth colabora y por lo que se entiende como aceptado por Reworth.  
					</p>
					<p>
						Monto de Reembolso: Es la cantidad de dinero puesta a disposición de Reworth por el Cliente para efectos de Cashback.
					</p>
					<p>
						Ofertas: son beneficios económicos en forma de descuentos, reembolsos, facilidades de pago, entre otros, que podrá ofrecer el Cliente al Consumidor a través de Reworth.  
					</p>
					<p>
						Perfil del Usuario: es el nombre de usuario y contraseña que utilizará el Cliente para acceder a la Plataforma y hacer uso de la misma.  
					</p>
					<p>
						Plataforma: El sistema informático web y móvil administrado por Reworth que permite a los Establecimientos programar instrucciones dirigidas a Reworth, así como administrar las Ofertas que en su caso suscriba el Cliente. 
					</p>
					<p>
						Porcentaje Cashback: : Es la proporción indicada por el Establecimiento, respecto al precio pagado por la adquisición de un bien o servicio en dicho establecimiento, que deberá ser reembolsada al Consumidor en virtud del Cashback.
					</p>
					<h3>
					Segunda. Servicios.
					</h3>
					<p>
						En virtud de estos Términos y Condiciones, Reworth proveerá al Cliente los siguientes servicios: 
					</p>
					<p>
					​	Acceso exclusivo a la Plataforma; Crear una cuenta de usuario a través de la cual se administren las Ofertas y los beneficios de los negocios y sucursales que se registren en la Plataforma; Conocer el estatus de las Ofertas; Conocer las estadísticas en cuanto a número de usuarios, total de transacciones, cantidad del consumo total por usuario, y el porcentaje promedio de transacciones que se realicen por día y; Recibir soporte técnico; Calculadora Cashback para que Reworth, en base a los datos ingresados por el Cliente pueda estimar el aumento de ventas potenciales del Cliente por el uso del Cashbak en su Establecimiento. 
					</p>
					<p>
					En caso de que el Cliente requiera modificar la Oferta, lo podrá hacer directamente desde la plataforma. Reworth se reserva el derecho de requerir información respecto de la modificación realizada y, en su caso, a su entera discreción, dejar sin efectos la modificación. 
					</p>
					<p>
						Queda entendido y el Cliente acepta que la Calculadora Cashback es una herramienta para estimar el impacto potencial del Cashback sobre un eventual aumento de ventas en su establecimiento, sin que dicha estimulación conlleve compromiso alguno por parte de Reworth en caso de que el Cashbak no llegue al aumento estimado de venta en el Establecimiento del Cliente, por lo que el Cliente deslinda Reworth de cualquier responsabilidad en caso de que el Cashbak no llegue al aumento estimado de venta en su Establecimiento. 
					</p>
					<h3>
						Tercera. Entrega de beneficios.
					</h3>
					<p>
						El Cliente se obliga a satisfacer las Ofertas, y en el caso de Cashbacks, a poner a disposición de Reworth el monto total correspondiente al porcentaje publicado y vigente por cada una de las compras que haya realizado el Consumidor, mediante el uso de los Métodos de Pago autorizados por Reworth, los cuales se harán del conocimiento del Cliente a través de la Plataforma y los canales de comunicación oficiales de Reworth.
					</p>
					<p>
						El Monto de Reembolso deberá ser puesto a disposición de Reworth previamente a que el Consumidor realice la compra del producto en el Establecimiento con el Método de Pago. Reworth solo tendrá la obligación de transferir el beneficio correspondiente al Porcentaje Cashback instruido por el Cliente, siempre que hubiera recibido los fondos correspondientes del Cliente con anterioridad. 
					</p>
					<p>
						El monto de Reembolso, así como cualquier otra cantidad que deba ser puesta a disposición o pagada por Reworth se podrá realizar: 
					</p>
					<p>
						Mediante depósito o transferencia bancaria al Consumidor a la CLABE asignada en la Plataforma; Mediante cargo a la tarjeta de crédito del Cliente. 
					</p>
					<h3>
						Cuarta. Obligaciones. 
					</h3>
					<p>
						Reworth se obliga a lo siguiente: 
					</p>
					<p>
						A tratar como confidencial toda la información a la que tenga acceso con motivo de la prestación de sus servicios, así como toda la información que reciba del Establecimiento.
					</p>
					<p>
						A no divulgar ni a servirse de la información confidencial del Establecimiento que posea con motivo de los servicios, ni a proporcionar a terceros, directa o indirectamente, información verbal o por escrito, sobre los métodos, sistemas y actividades y en general sobre toda la información confidencial de cualquier clase correspondiente al Establecimiento. 
					</p>
					<p>
						A no retener o divulgar el contenido de cualquier documento que se le hubiere  proporcionado, facilitado o hubiere obtenido en virtud de la prestación de los servicios, salvo por requerimiento de autoridad administrativa o judicial competente.
					</p>
					<p>
						A darle soporte y mantenimiento a la Plataforma para que opere en óptimas condiciones. 
					</p>
					<p>
						El Cliente se obliga a lo siguiente: 
					</p>
					<p>
						A pre fondear en tiempo y forma a Reworth el beneficio a otorgarse en virtud de las Ofertas. 
					</p>
					<p>
						A tratar como confidencial toda la información que reciba de Reworth y la que se genere con motivo de la presente relación.
					</p>
					<p>
						A no divulgar ni a servirse personalmente de la información confidencial de Reworth, que sea de su conocimiento con motivo de la prestación de los servicios, así como a no proporcionar a terceros, directa o indirectamente, información verbal o por escrito, sobre los métodos, sistemas y actividades y en general sobre toda la información confidencial de cualquier clase que observe en la Plataforma.
					</p>
					<p>
						A no retener ni divulgar el contenido de cualquier documento que se le hubiere proporcionado, facilitado o obtenido en virtud de la prestación de los servicios, salvo por requerimiento de autoridad administrativa o judicial competente. 
					</p>
					<h3>
						Quinta. Uso de la Plataforma. 
					</h3>
					<p>
						Para acceder al servicio de Reworth, el Cliente deberá registrarse en la Plataforma y crear un perfil de usuario, así como cumplir con todos los requisitos establecidos por Reworth. 
					</p>
					<p>
						Para acceder al servicio de Reworth, el Cliente deberá registrarse en la Plataforma y crear un perfil de usuario, así como cumplir con todos los requisitos establecidos por Reworth. 
					</p>
					<p>
						Existen dos tipos de usuarios con capacidad para registrarse en la Plataforma: Comercio e Institución Financiera.
					</p>
					<p>
						El Cliente registrado tendrá acceso a la plataforma exclusivamente para su propio beneficio. 
					</p>
					<p>
						El Cliente deberá mantener en todo momento sus credenciales de acceso protegidas, su información de perfil completa, correcta y veraz. 
					</p>
					<p>
						El Cliente está de acuerdo en que un usuario registrado será identificado por sus credenciales de acceso y éstas deberán ser utilizadas solo por un (1) individuo.
					</p>
					<p>
						El Cliente es responsable absoluto de mantener el resguardo de sus credenciales de acceso y no deberá compartir esta información con terceros, incluyendo personas dentro de Reworth. Reworth nunca pedirá al usuario sus accesos para proveer algún servicio o soporte. 
					</p>
					<p>
						El Cliente es responsable absoluto del uso de la Plataforma bajo sus credenciales de acceso. 
					</p>
					<p>
						Si el Cliente tiene o cree tener conocimiento de que sus credenciales de acceso han sido vulneradas, deberá notificar a Reworth inmediatamente.
					</p>
					<p>
						Reworth podrá recolectar información personal del Cliente para mantener el servicio, administrar la cuenta del Cliente, enviar notificaciones o enviar información del servicio o de facturación por servicios contratados y para todos los efectos permitidos por su Aviso de Privacidad. 
					</p>
					<p>
						Reworth también podrá recolectar información de uso del sistema. El Cliente está de acuerdo en que Reworth utilice dicha información para optimización de su infraestructura, mejora de la experiencia del usuario dentro de sus productos, así como para sus propósitos de mejora continua.
					</p>
					<p>
						Reworth se reserva el derecho de aceptar, declinar o cancelar el acceso de cualquier Cliente a la Plataforma. 
					</p>
					<p>
						La estructura de la Plataforma, así como su navegación, menú, contenido, etc puede ser modificada a discreción por Reworth. El uso de la Plataforma de forma posterior a dichas modificaciones por parte del Cliente se tendrá como un consentimiento tácito a dichas modificaciones.  
					</p>
					<p>
						En cualquier momento el Cliente podrá enviar a Reworth un correo electrónico  a la dirección info@Reworth.co con comentarios y/o sugerencias sobre la Plataforma, los cuales no se entenderán como forzosos ni vinculantes y Reworth podrá tomarlos o no en cuenta para mejorar la experiencia dentro de la Plataforma.  
					</p>
					<p>
						Es posible que la Plataforma contenga enlaces a direcciones web de terceros o externos a la propia Plataforma. El contenido y la seguridad en dichas direcciones no es responsabilidad de Reworth por lo que el riesgo de acceder o no a dichos sitios correrá por su cuenta.  
					</p>
					<p>
						El Cliente acepta y reconoce que por la naturaleza de la Plataforma, esta podrá ser inhabilitada de tiempo en tiempo para efectos de mantenimiento, por lo que en caso de que el Cliente no pueda acceder a la misma por cuestiones de mantenimiento y mejoras, no se entenderá en ningún momento como incumplimiento por parte de Reworth, pudiendo el Cliente acceder a la Plataforma una vez que esta sea habilitada.  
					</p>
					<p>
						El uso de la plataforma está condicionado a que su dispositivo (tales como  navegador de Internet, smartphone, tableta, etc.) cumpla con las especificaciones técnicas requeridas por Reworth.  
					</p>
					<h3>
						Sexta. Limitación de uso. 
					</h3>
					<p>
						Queda expresamente prohibido al Cliente vender, alquilar, redistribuir y/o transferir el contenido de la Plataforma, así como permitir el acceso a terceros al contenido de la Plataforma o a la Plataforma misma.  
					</p>
					<p>
						Reworth mantendrá en todo momento la titularidad sobre todas las copias de las aplicaciones de software de la Plataforma que permiten el uso de la misma, incluyendo el código fuente y código objeto de programación de la página web, así como de las herramientas digitales de la Plataforma y de todo el contenido que sea propiedad de Reworth. Por tanto, el Cliente acepta expresamente que el uso de la Plataforma y su contenido se otorga como una licencia, sin que se  transmita o ceda derecho de propiedad intelectual alguno.  
					</p>
					<p>
						Reworth podrá bloquear, interrumpir o restringir el uso y acceso a la Plataforma y a la página web cuando lo considere necesario, así como eliminar o dar de baja la Plataforma o cualquiera de las partes que la componen.  
					</p>
					<p>
						Queda estrictamente prohibido el uso de la Plataforma para actividades delictivas o que estén relacionadas con la comisión o tentativa de comisión de delitos o hechos ilícitos.  
					</p>
					<h3>
						Séptima. Especificaciones. 
					</h3>
					<p>
						Al utilizar nuestros servicios, el Cliente acepta que los mismos serán aplicables bajo los siguientes términos: 
					</p>
					<p>
						Los beneficios se deberán aplicar en todas las ocasiones en las que el Consumidor utilice el Método de Pago autorizado por Reworth.  
					</p>
					<p>
						Los beneficios serán aplicables únicamente para las tarjetas  participantes o Métodos de Pago autorizados por Reworth.  
					</p>
					<p>
						Las Ofertas no son acumulables ni transferibles. 
					</p>
					<p>
						Los beneficios están limitados a los Consumidores autorizados por Reworth. 
					</p>
					<p>
						En caso de cualquier abuso en los términos y condiciones aquí establecidos, se procederá a la cancelación del Servicio.  
					</p>
					<h3>
						Octava. Uso de nuestros Servicios. 
					</h3>
					<p>
						Al inscribirse a la Plataforma, el Cliente reconoce y acepta que Reworth le está otorgando una licencia de uso temporal, no exclusiva, revocable y limitada para que utilice la el logo de Reworth para promocionar Ofertas para su negocio, en los términos que se describen en estos Términos y Condiciones del Servicio.
					</p>
					<p>
						Al hacer uso de nuestros Servicios, el Cliente deberá seguir las políticas para el uso de los mismos contenidos en los presentes términos y condiciones y deberá abstenerse en todo momento de utilizar los servicios de forma indebida, por lo que se obliga a ceñirse a la legislación y  regulación mexicana aplicable a los mismos. Cualquier incumplimiento del Cliente a las políticas de Reworth o a la legislación y regulación mexicana aplicable, faculta a Reworth suspender o dejar de proveer sus servicios y en su caso tomar las acciones legales correspondientes.  
					</p>
					<p>
						Asimismo, salvo previa autorización que otorgue Reworth a los Clientes para utilizar el logotipo de Reworth en el marco de la licencia arriba mencionada para que lleve a cabo las actividades de promoción de las Ofertas, el uso de nuestros servicios no implica ningún otro otorgamiento de derechos en materia de propiedad intelectual sobre los mismos. Por lo anterior, el Cliente no podrá utilizar la propiedad intelectual de Reworth y demás contenido e información a la que tenga acceso sin el otorgamiento del permiso correspondiente por parte de Reworth, y en todo momento, toda la información confidencial definida en el Aviso de Privacidad así como cualquier derecho comercial, derecho de autor, invento descubrimiento o cualquier patente que ampare el invento o descubrimiento o cualquier otro derecho de propiedad intelectual,será y se mantendrá propiedad exclusiva de Reworth. 
					</p>
					<p>
						Reworth se reserva el derecho:
					</p>
					<p>
						De exigir al Cliente que cese la utilización del logotipo de Reworth en cualquier momento. 
					</p>
					<p>
						De especificar la forma en que el Cliente podrá utilizar el logotipo de Reworth. 
					</p>
					<p>
						Todos los logotipos y marcas que se utilizan en relación con la prestación de los Servicios son propiedad única y exclusiva de las compañías a las que hacen referencia y se muestran con carácter meramente ilustrativo, por lo que su uso es responsabilidad exclusiva del propietario o licenciatario correspondiente, en su caso. 
					</p>
					<p>
						No obstante lo anterior, el Cliente acepta que para efectos de promoción, Reworth así como las instituciones financieras con las cuales Reworth coopere para ofrecer el sistema de Cashback podrán hacer uso de los logotipos sin que por ello puedan solicitar el pago de contraprestación alguna, por lo que confieran a Reworth y a las instituciones financieras correspondientes, una licencia de uso temporal, no exclusiva, revocable y limitada para que utilicen su logo a efectos de promoción. Independientemente de lo anterior, los Clientes mantendrán en todo momento el derecho de solicitar a Reworth y/o la institución bancaria correspondiente
					</p>
					<p>
						Que cesen la utilización de su logotipo en cualquier momento. 
					</p>
					<p>
						De especificar la forma en que podrán utilizar su logotipo.
					</p>
					<h3>
						Novena. Privacidad y protección de datos. 
					</h3>
					<p>
						Todos los datos que el Cliente proporcione a Reworth a través de la Plataforma serán tratados en apego a la Ley Federal de Protección de Datos Personales en Posesión de los Particulares y del Aviso de Privacidad de Reworth, mismo que puede ser consultado en https://www.Reworth.co/aviso-de-privacidad y en la Plataforma en cualquier momento
					</p>
					<h3>
						Décima. Limitación y liberación de responsabilidad para Reworth. 
					</h3>
					<p>
						Salvo lo establecido en la legislación aplicable, Reworth no será responsable de cualesquier clase de daños o perjuicios que pudieran sufrir los Clientes de manera directa o indirecta por el uso de la Plataforma.  
					</p>
					<p>
						En ningún caso, Reworth será responsable por pérdidas o daños que no sean  razonablemente previsibles.  
					</p>
					<p>
						Al aceptar los presentes términos y condiciones, el Cliente acepta que no se reserva, ni ejercerá ninguna acción de cualquier naturaleza, en contra de  Reworth, sus socios, accionistas, empleados, apoderados y colaboradores, empresas filiales y/o subsidiarias, o cualquier otro miembro de Reworth, así como socios comerciales y proveedores, que pudiera derivar en forma directa o indirecta de cualquier riesgo o daño en sus bienes o persona, honra o reputación que pueda sufrir derivado del uso de la Plataforma.  
					</p>
					<p>
						El Cliente se obliga a no realizar ningún acto ni utilizar cualquier software o método para ingresar y/o eliminar la seguridad de la Plataforma para acceder al código fuente, algoritmos ni a los servidores de Reworth ni de la Plataforma, respondiendo por las consecuencias civiles y/o penales que dicha conducta genere.  
					</p>
					<p>
						El Cliente deberá tener vigente y cumplir con toda la normatividad correspondiente en relación a su establecimiento y servicios y/o productos, en específico en materia de salubridad, permisos delegacionales sobre establecimientos mercantiles, autorizaciones, permisos entre otros, y no dar bebidas alcohólicas a menores de edad, propiedad intelectual, así como permisos y autorizaciones para premios y concursos.  
					</p>
					<p>
						En caso de intoxicación, lesión, daño o muerte derivada del consumo de algún alimento o bebida por algún consumidor, el Cliente responderá y sacará en paz y a salvo a Reworth respecto de cualquier reclamación que pudiera generar el Consumidor en razón del bien o servicio recibido por parte del Cliente. 
					</p>
					<p>
						Los servicios brindados a través de la Plataforma surtirán efectos únicamente en el territorio mexicano.  
					</p>
					<h3>
						Décima Primera. Renuncia a garantías. 
					</h3>
					<p>
						Reworth no establece representación o garantía alguna sobre la exactitud, confiabilidad o integridad del contenido de la Plataforma. Dentro de las limitantes establecidas por la Ley aplicable en la materia, el Cliente renuncia a toda garantía, explícita o implícita, para hacer uso de la Plataforma. Reworth no garantiza que la Plataforma o el servidor que la hace disponible estén libres de software malicioso como “virus informáticos” por lo que el uso del sitio lo hace el Cliente bajo su propio riesgo y responsabilidad.
					</p>
					<h3>
						Décima Segunda. Acerca de estas Condiciones. 
					</h3>
					<p>
						Estos términos y condiciones gobiernan la relación entre Reworth y el Cliente y no  generan ningún tipo de derechos a favor de terceros.  
					</p>
					<p>
						En caso de que el Cliente no cumpla con alguna de estas condiciones, y Reworth no actúe como corresponda de forma inmediata, esto no implicará de ninguna manera  una renuncia de cualquier derecho que le pudiera corresponder a Reworth.  
					</p>
					<p>
						Al aceptar estas condiciones, el Cliente está aceptando que la legislación  mexicana y los tribunales en la Ciudad de México sean los competentes en  caso de cualquier controversia que surja o se relacione con las presentes  condiciones o los servicios objeto de estos Términos y Condiciones, renunciando expresamente al foro que pudiese corresponderle considerando su domicilio actual o futuro. 
					</p>
					<h3>
					Décima Tercera. Información de contacto. 
					</h3>
					<p>
						En caso de que el Cliente tenga cualquier pregunta se puede poner en contacto con  Reworth a la siguiente dirección electrónica info@Reworth.co
					</p>
					<h3>
						Décima Cuarta. Otros.
					</h3>
					<p>
						Reworth, a su discreción, se reserva el derecho de: (i) cambiar los Términos y  Condiciones en cualquier momento, (ii) dar seguimiento y eliminar información  proporcionada por el Cliente a la Plataforma y (iii) limitar o eliminar la  disponibilidad de la Plataforma, en cualquier momento, sin previo aviso a entera discreción de Reworth. Si se llegara a determinar que algún término, condición  o disposición de estos Términos y Condiciones es ilegal, inválida, nula o por cualquier razón, inaplicable, la validez y aplicación de las demás disposiciones  no será de ninguna manera afectada o deteriorada. 

					</p>
					<p>
						Estos Términos y Condiciones constituyen un acuerdo completo entre el Cliente y Reworth.  
					</p>
					<p>
					Todas las modificaciones que sean realizadas a los presentes Términos y  Condiciones surtirán efectos en el momento en el que sean actualizados. Asimismo, los presentes Términos y Condiciones aplicarán a cualquier sitio web, y cualquier otra herramienta o tecnología cuya titularidad pertenezca a Reworth, por tanto, los presentes Términos y Condiciones se entenderán como aplicables y referidos a cualquier tipo de plataforma o  herramienta de Reworth.  
					</p>
					<p>
						Cualquier incumplimiento a los presentes Términos y Condiciones faculta a Reworth para dar por terminada cualquier relación con el Cliente, sin necesidad de requerimiento  judicial.  
					</p>
					<p>
						Al utilizar la Plataforma, el Cliente otorga su consentimiento a todos los términos y condiciones establecidos en el presente.   
					</p>

				</div>
			</div>
		)}

		<div className="footer">
			<div className="logo footerImg">
                <img src={logoFooter} alt="Invex logo white" />
			</div>

			<div className="terminosCondiciones">
                    <p onClick={() => setIsModalOpen(true)}> 
                        Términos y condiciones del programa
                    </p>
            </div>

			<div className="derechosReservados">

				<p>
				{`Suburbia Ⓡ ${year} - Todos los derechos reservados`}
				</p>

			</div>
		</div>
	</>
	);
};

